// src/utils/common.js
/**
 * 拨打电话
 * @id {(string)} 多个id用 , 分隔
 * @deleteFun {Function} 删除数据调用的Api方法
 * @callback {Function} 删除成功的回调
 * @returns {null}
 */
export const callPhone = (phoneNumber) => {
  console.log(phoneNumber);
  window.location.href = "tel://" + phoneNumber;
}
/**
 * 计算地图中心点
 * @points [] [{lat:'',lng:'',}]
 * @returns {lat:'',lng:''}
 */
export const calculateCenter = (points) => {
  console.log(points)
  var point_num = points.length; //坐标点个数
  var X = 0, Y = 0, Z = 0;
  for(let i = 0; i< points.length; i++) {
    if (points[i] == '') {
      continue;
    }
    var lat, lng, x, y, z;
    lat = parseFloat(points[i].lat) * Math.PI / 180;
    lng = parseFloat(points[i].lng) * Math.PI / 180;
    x = Math.cos(lat) * Math.cos(lng);
    y = Math.cos(lat) * Math.sin(lng);
    z = Math.sin(lat);
    X += x;
    Y += y;
    Z += z;
  }
  X = X / point_num;
  Y = Y / point_num;
  Z = Z / point_num;

  var tmp_lng = Math.atan2(Y, X);
  var tmp_lat = Math.atan2(Z, Math.sqrt(X * X + Y * Y));
  var res = {lat: tmp_lat * 180 / Math.PI, lng: tmp_lng * 180 / Math.PI};
  console.log('中心点：',res)
  return res
}



// WEBPACK FOOTER //
// ./src/utils/common.js